import React from 'react';

function Footer(){
    return (
        <footer className="main-footer text-center">
        {/* &copy;{(new Date()).getFullYear()} <a href="https://topventory.com" className='text-muted text-underline'>Topventory</a>. */}
        Powered by <a target="_blank" href="https://topventory.com" className='text-muted'>Topventory</a>
        </footer>
    )
}

export default Footer;
